import { showMessage } from "react-native-flash-message";

const toastStyle = {
    borderRadius: 12,
    marginHorizontal: 16,
    marginTop: 8,
    paddingVertical: 10,
    zIndex: 99999,
    elevation: 99999,
    shadowColor: "#000",
    shadowOpacity: 0.16,
    shadowRadius: 12,
    shadowOffset: { width: 0, height: 8 },
};

const titleStyle = {
    fontWeight: "800" as const,
    fontSize: 14,
};

const textStyle = {
    fontWeight: "600" as const,
    fontSize: 12,
    lineHeight: 18,
};

export const Flash = {
    success: (message: string, description?: string) =>
        showMessage({
            message,
            description,
            type: "success",
            icon: "success",
            floating: true,
            position: "top",
            duration: 3500,
            statusBarHeight: 40,
            style: toastStyle,
            titleStyle,
            textStyle,
        }),

    error: (message: string, description?: string) =>
        showMessage({
            message,
            description,
            type: "danger",
            icon: "danger",
            duration: 4500,
            position: "top",
            floating: true,
            statusBarHeight: 40,
            style: toastStyle,
            titleStyle,
            textStyle,
        }),

    info: (message: string, description?: string, duration = 4000) =>
        showMessage({
            message,
            description,
            type: "info",
            icon: "info",
            duration,
            position: "top",
            floating: true,
            statusBarHeight: 40,
            style: toastStyle,
            titleStyle,
            textStyle,
        }),
};
